module.exports = __webpack_public_path__ + "c493eeb7f53459604cd5b1b9378bf043.jpg";